import { useCallback } from 'react';
import {
    UsageActionEnumType,
    UsageCompletionEnum,
    UsageSourceModuleEnum,
    EntityTypeEnum,
} from '@mark43/cad-api';
import { useUsageLog } from './use-usage-log';
import { AttachmentsPanelType } from '../../attachments/types';

interface UseAttachmentUsageLogParams {
    entityId: number;
    entityType: AttachmentsPanelType;
    entityNumber?: string;
}

export function useAttachmentUsageLog({
    entityId,
    entityType,
    entityNumber,
}: UseAttachmentUsageLogParams) {
    const { mutate: createUsageLog } = useUsageLog();

    const logAttachmentAction = useCallback(
        function logAttachmentAction(
            action: UsageActionEnumType,
            attachmentId: number,
            fileName: string
        ) {
            const entityTypeLabel = entityType === 'BOLO' ? 'BOLO' : 'CAD Event';
            const entityNumberPart = entityNumber ? `#${entityNumber}` : '#unknown';
            const actionLabel =
                action === 'VIEWED_ATTACHMENT' ? 'Viewed Attachment' : 'Downloaded Attachment';
            const primaryEntityTitle = `${actionLabel} ${fileName} for ${entityTypeLabel} ${entityNumberPart}`;

            const basePayload = {
                action,
                completion: UsageCompletionEnum.SUCCEEDED.name,
                sourceModule:
                    entityType === 'BOLO'
                        ? UsageSourceModuleEnum.BOLO.name
                        : UsageSourceModuleEnum.CAD_EVENTS.name,
                primaryEntityTitle,
            };

            createUsageLog({
                ...basePayload,
                primaryEntityType: EntityTypeEnum.ATTACHMENT.name,
                primaryEntityId: attachmentId,
            });

            createUsageLog({
                ...basePayload,
                primaryEntityType:
                    entityType === 'BOLO'
                        ? EntityTypeEnum.BOLO.name
                        : EntityTypeEnum.CAD_AGENCY_EVENT.name,
                primaryEntityId: entityId,
            });
        },
        [createUsageLog, entityId, entityType, entityNumber]
    );

    return { logAttachmentAction };
}
